import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'history' }).lazy(() =>
  import('./site-history.lazy.tsx').then((module) => module.Route),
);
